import { any } from "prop-types"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { GetDocumentVistaPrevia } from "../../../helpers/files"
import { authenticationService } from "../../../services/authentication.service"
import { UserData } from "../../Sidebar/Sidebar_Principal"
import { alertService } from "../../Varios/alert_service"
import Cargando from "../../Varios/Cargando"
import ModalVistaPreviaDocumentos from "../../Varios/Modals/ModalVistaPreviaDocumentos"
import { AnularNotificacionEmbarazo, NotificacionEmbarazoCreacion, ObtenerInformacionGeneralNotificacionEmbarazos } from "./FunctionsNotificacionEmbarazos"
import TableNotificacionEmbarazo from "./TablaNotificacionEmbarazo"
import { InformacionGeneralNotificacion, NotificacionesEmbarazoHist } from "./TypesNotificacionEmbarazo"
import { Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import { FileInfoUrl, ResponseRequest } from "../../Types/GeneralTypes"
import InputFileUpload from "../../Varios/InputFileUpload"
import { formatDateToString, PruebaSolucion2, SumarMesesFecha } from "../../../functions/DatesFunctions"
import Datepicker from "../../Varios/Datepicker"
import { ScrollToTop } from "../../../functions/LayoutFunctionst"
import Datepicker2 from "../../Varios/DatepickerNew"
import InputFileUpload2 from "../../Varios/InputFileUploadNew"
import { formatoFecha } from "../../Admin/Inicio-Admin/Dashboard_Individual_Admin"
import ModalConfirmacion from "../../Varios/Modals/ModalConfirmacion"

import Swal from 'sweetalert2'

import ExitoSVG from "assets/icons/Permisos/Exitosa.svg"
import ErrorSVG from "assets/icons/Permisos/Error.svg"
import AlertaSVG from "assets/icons/Permisos/Alerta.svg"
import DatepickerModal from "components/Varios/DatePickerModal"

type StateNotificacionEmbarazo = {
    datosGenerales: InformacionGeneralNotificacion,
    loadingDG: boolean,
    mensajeError: string,
    idRegimenLaboral: number[],
    fechaControlHorario: Date,
    puedeSolicitarPorHorario: boolean
}

type StateModalHistoricoDetalle = {
    loadingInformacion: boolean,
    anio: number,
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

type stateModal = {
    showModal: boolean,
    notificacion?: NotificacionesEmbarazoHist,
    content: HTMLElement | undefined

}

export default function NotificacionEmbarazo() {

    const defaultState: StateNotificacionEmbarazo = {
        datosGenerales: {
            anio: -1,
            historial: [], acuerdoMediosElectronicos: true, 
        },
        loadingDG: false,
        mensajeError: "",
        idRegimenLaboral: [],
        fechaControlHorario: new Date(),
        puedeSolicitarPorHorario: false
    }

    const defaultStateModalHistoricoDetalle: StateModalHistoricoDetalle = {
        loadingInformacion: false,
        
        anio: -1,
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {

        loading: false,
        url: ""
    }

    const defaultStateModal: stateModal = {
        notificacion: undefined,
        showModal: false,
        content: undefined
    }

    const [stateNotificacionEmbarazo, setstateNotificacionEmbarazo] = useState<StateNotificacionEmbarazo>(defaultState)
    const [stateModalHistoricoDetalle, setstateModalHistoricoDetalle] = useState<StateModalHistoricoDetalle>(defaultStateModalHistoricoDetalle)
    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)
    const [stateModal, setstateModal] = useState<stateModal>(defaultStateModal);
    const [isSubmitting, setIsSubmitting] = useState(false); 

    const [fechaNotificacion, setfechaNotificacion] = useState<Date | null>(null)
    const [fechaEstParto, setfechaEstParto] = useState<Date | null>(null)
    const [fechaInterrupcion, setfechaInterrupcion] = useState<Date | null>(null)
    const [semanas, setSemanas] = useState<number | null>(null)
    const [certMedico, setCertMedico] = useState<Array<FileInfoUrl>>([])
    function HandleErrorInformacionGeneral(message?: string) {
        const mensaje = message ?? "Ha ocurrido un error al intentar obtener informacion de sus solicitudes"
        alertService.error(mensaje)
    }

    async function ObtenerDatosGenerales() {
        setstateNotificacionEmbarazo({ ...stateNotificacionEmbarazo, loadingDG: true })
        const respuesta = await ObtenerInformacionGeneralNotificacionEmbarazos(HandleErrorInformacionGeneral)
        const listaRegimenServidor: number[] = authenticationService.currentUserValue.regimen_usuario;
        if (respuesta.status === 200) {
            setstateNotificacionEmbarazo({ ...defaultState, datosGenerales: respuesta.dataResponse, loadingDG: false, idRegimenLaboral: listaRegimenServidor })
        }
        else {
            setstateNotificacionEmbarazo({ ...defaultState, loadingDG: false, mensajeError: respuesta.errorMessage ?? "" })
        }
    }

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //ObtenerDatosGenerales();
    }, [])

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    const handleSemanasChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = parseInt(event.target.value);
        if (newValue >= 1 && newValue <= 40) {
            setSemanas(newValue);
        }
    };

    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP])


    function GetHTMLNotificacionIngresadas(solicitudes: Array<NotificacionesEmbarazoHist>): any {
        const htmlRowsSolicitudes = solicitudes.map((val, ind) => {
            var fechaCertificado = val.fechacertificado ?? new Date()
            var fechaEstimadaParto = val.fechaestimadaparto ?? new Date()
            const fila = (
                <Row key={"SolicitudesVacacionesUsuario" + ind} className="mt-2 rowSolicitarPermisos">
                    <Col md={3} className="pr-0">
                        <FormGroup>
                            <Label for="Fecha">
                                Fecha Certificado:
                            </Label>
                            <Input type="text" readOnly className="bold" value={formatoFecha(fechaCertificado.toString())}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <Label for="Fecha">
                                Semanas:
                            </Label>
                            <Input type="text" readOnly className="bold" value={val.semanascertificado}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label for="Fecha">
                                Fecha Estimada Parto:
                            </Label>
                            <Input type="text" readOnly className="bold" value={formatoFecha(fechaEstimadaParto.toString())}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={3}>
                        <FormGroup>
                            <Label for="Fecha">
                                Fecha Fin por Interrupción:
                            </Label>
                            {DatePickerFechaFin(val.fechacertificado)}
                        </FormGroup>
                    </Col>
                    
                </Row>
            )
            return fila;

        })



        return htmlRowsSolicitudes;
    }

    const handleClickAnular = (notificacion: NotificacionesEmbarazoHist) => {
        const content: any = GetHTMLNotificacionIngresadas([notificacion])
        setstateModal({
            showModal: true,
            notificacion,
            content
        });
    }

    const tablaNotificacionEmbarazos = useMemo(() => {
        if (stateNotificacionEmbarazo.loadingDG) {
            return <Cargando />
        }
        else if (stateNotificacionEmbarazo.mensajeError) {
            return <div>No ha sido posible obtener información</div>
        }
        else if (!stateNotificacionEmbarazo.mensajeError && stateNotificacionEmbarazo.datosGenerales.historial.length === 0) {
            return <div>No hay notificaciones de embarazo por mostrar</div>

        }
        else if (!stateNotificacionEmbarazo.loadingDG && stateNotificacionEmbarazo.datosGenerales.historial.length > 0) {
            return (
                <TableNotificacionEmbarazo
                    dataFilas={stateNotificacionEmbarazo.datosGenerales.historial}
                    onClickVerDocumento={async (referencia: string) => await onClickVerDoc(referencia)}
                    onClickAnular={async (notificacion: NotificacionesEmbarazoHist) => await handleClickAnular(notificacion)}
                />

            )
        }
    }, [stateNotificacionEmbarazo])


    const DatePickerFecha = useCallback(() => {

        const fechaActual = new Date();
        const fechaminima = SumarMesesFecha(fechaActual, -9);
        const fechaMaxima = fechaActual;
        return (
            <Datepicker2
                value={fechaNotificacion}
                minHeigth={30 }
                name="fechanotificacion"
                id="fechanotificacion"
                onChange={(e) => setfechaNotificacion(e)}
                min={fechaminima}
                max={fechaMaxima}
                showDisabledMonthNavigation={true}
            />
        )
    }, [fechaNotificacion])

    const handleDateChange = (selectedDate) => {
        if (selectedDate) {
            setfechaInterrupcion(selectedDate);
             // Debugging output
        }
    };

    const DatePickerFechaFin = useCallback((fechaCertificado) => {
        const fechaActual = new Date();
        const fechaMinima = fechaCertificado ? new Date(fechaCertificado) : SumarMesesFecha(fechaActual, -9);
        const fechaMaxima = fechaActual;
        
        

        return (
            <DatepickerModal
                value={fechaInterrupcion}
                minHeigth={30}
                name="fechainterrupcion"
                id="fechainterrupcion"
                onChange={(e) => setfechaInterrupcion(e)}
                min={fechaMinima}
                max={fechaMaxima}
                showDisabledMonthNavigation={true}
            />
        );
    }, [fechaInterrupcion]);


    useEffect(() => {
        if (fechaNotificacion && semanas) {
            const estimado = 40 - semanas;
            const f_certificado = new Date(fechaNotificacion);
            const fechaCertificadoString = `${f_certificado.getDate()}/${f_certificado.getMonth() + 1}/${f_certificado.getFullYear()}`;
            const fechaCertificadoParts = fechaCertificadoString.split("/");
            const fechaCertificado = new Date(
                parseInt(fechaCertificadoParts[2]),
                parseInt(fechaCertificadoParts[1]) - 1,
                parseInt(fechaCertificadoParts[0])
            );
            fechaCertificado.setDate(fechaCertificado.getDate() + estimado * 7);
            setfechaEstParto(fechaCertificado);
        }
    }, [fechaNotificacion, semanas]);

    const validarCamposn = () => {
        return fechaNotificacion != undefined && semanas != undefined && certMedico.length != 0
    }
    /*const handleFileUpload = (tipoEvidencia, uploadFile) => {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo: FileInfoUrl = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, url: src, nombreFile: "certificadoMedico.pdf" };
        setCertMedico(prevState => [...prevState, fileInfo]);
    };*/
    const handleFileUpload = (tipoEvidencia, uploadFile) => {
        const src = window.URL.createObjectURL(uploadFile);
        const fileInfo: FileInfoUrl = { type: tipoEvidencia, file: uploadFile, id: tipoEvidencia, url: src, nombreFile: uploadFile.name };
        setCertMedico([fileInfo]);
    };

    const AuxiliarCrearNotificacionEmbarazoPost = useCallback(
        () => {
            if (fechaNotificacion && fechaEstParto && semanas) {
                const formData = new FormData()
                formData.append('FechaCertificado', PruebaSolucion2(fechaNotificacion).toString())
                formData.append('FechaEstimadaParto', PruebaSolucion2(fechaEstParto).toString())
                formData.append('SemanasCertificado', semanas.toString())
                if (certMedico.length > 0) {
                    certMedico.map((fileData) => {
                        formData.append('CertMedico', fileData.file, fileData.file.name);
                    });
                }
                return formData;
            } 
        },
        [fechaNotificacion, fechaEstParto, semanas, certMedico],
    )

    const limpiarFormulario = useCallback(
        () => {

            setfechaNotificacion(null)
            setfechaInterrupcion(null)
            setfechaEstParto(null)
            setSemanas(null)
            setCertMedico([])

        },
        [fechaNotificacion, fechaEstParto, semanas, setCertMedico],
    )

    const isOverlapping = (newStartDate: Date, newEndDate: Date, existingNotifications: NotificacionesEmbarazoHist[]): boolean => {
        return existingNotifications.some(notification => {
            const existingStartDate = new Date(notification.fechacertificado);
            const existingEndDate = new Date(notification.fechaestimadaparto);
            return (newStartDate < existingEndDate && newEndDate > existingStartDate);
        });
    };

    const OnClickAccionBotonEnviar = useCallback(async (): Promise<number> => {

        // Evitar múltiples clics si ya se está enviando la notificación
        if (isSubmitting) {
            await showAlert("Enviando notificación, por favor espere...", AlertaSVG, false);
            return -1;
        } // Si ya estamos enviando, mostrar una alerta

        var respuesta: ResponseRequest = { status: -1 };
        if (fechaNotificacion && fechaEstParto && semanas) {
            const historialSinInterrupcion = stateNotificacionEmbarazo.datosGenerales.historial.filter(notificacion => notificacion.fechainterrupcion === null);

            if (isOverlapping(fechaNotificacion, fechaEstParto, historialSinInterrupcion)) {
                await showAlert("No se puede ingresar una nueva notificación que se superponga con una notificación anterior", ErrorSVG, false);
                return -1;
            }
            const solicitudNueva = AuxiliarCrearNotificacionEmbarazoPost();
            if (solicitudNueva === undefined) {
                await showAlert("No ha sido posible ingresar la solicitud", ErrorSVG, true);
            }
            else {
                // Deshabilitar el botón mientras se realiza la solicitud
                setIsSubmitting(true); // Inicia el estado de envío

                respuesta = await NotificacionEmbarazoCreacion(solicitudNueva, setIsSubmitting);

            }

            if (respuesta.status === 200) {
                await showAlert("La notificación ha sido guardada con éxito", ExitoSVG, true);

                limpiarFormulario()

                await ObtenerDatosGenerales()

                ScrollToTop();
                return 200;
            }
            else {
                //alertService.error(respuesta.errorMessage ?? "No ha sido posible ingresar la solicitud de permiso y/o licencia.Intente más tarde")
                await showAlert(respuesta.errorMessage ?? "No ha sido posible ingresar la solicitud de permiso y/o licencia.Intente más tarde", ErrorSVG, true);
                limpiarFormulario()
                await ObtenerDatosGenerales()
                ScrollToTop();
                return respuesta.status;
            }

        } else {
            // Si no se cumple la condición, devolver un código de error
            return -1;
        }



    }
        , [isSubmitting, limpiarFormulario, AuxiliarCrearNotificacionEmbarazoPost])

    async function OnCloseModalConfirmacionAnulacion() {
        await ObtenerDatosGenerales()
        setstateModal(defaultStateModal)
        ScrollToTop();
    }

    async function AnularNotificacion(idNotificacion: number, fechaInterrupcion: Date | null) {

        if(fechaInterrupcion === null){
            await showAlert("Debe de seleccionar la fecha de interrupción del embarazo", ErrorSVG, true);
            return -1;
        }else{
            const statusAnulacion = await AnularNotificacionEmbarazo(idNotificacion, fechaInterrupcion);
            if (statusAnulacion === 1) {
                await showAlert("Se realizó el registro con éxito", ExitoSVG, true);
            }
            else {
    
                await showAlert("Ha ocurrido un inconveniente al intentar realizar el registro", ErrorSVG, false);
            }
            return statusAnulacion;
        }
        
    }


    return (
        <div className="content">
            <div className="titulo_seccion mb-5"> NOTIFICACIÓN DE EMBARAZO</div>
            

            <Row>
                <>
                    <Col md={2} className="pr-0">
                        <FormGroup>
                            <Label for="fechanotificacion">
                                Fecha de certificado*
                            </Label>
                            {DatePickerFecha()}
                        </FormGroup>
                    </Col>
                    <Col md={1} className="pr-0">
                        <FormGroup>
                            <Label for="semanas">
                                Semanas*
                            </Label>
                            <Input type="number" id="semanas" value={semanas || ''} onChange={handleSemanasChange} min={1} max={40}></Input>
                        </FormGroup>
                    </Col>
                    <Col md={2} className="pr-0">
                        <FormGroup>
                            <Label for="fechaparto">
                                Fecha estimada de parto
                            </Label>
                            <Input value={fechaEstParto ? formatDateToString(fechaEstParto) : ""} disabled />
                        </FormGroup>
                    </Col>
                    <Col md={2} className="pr-0">
                        <FormGroup>
                            <Label for="archivo">
                                Subir evidencia*
                            </Label>
                            <InputFileUpload2
                                icon="upload"
                                name="CERT"
                                onChange={handleFileUpload}
                                placeholder={""} 
                                fileArray={certMedico}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={1} className="align-self-center d-flex justify-content-start">
                        <Button disabled={!validarCamposn() && isSubmitting} onClick={() => OnClickAccionBotonEnviar()}>ENVIAR NOTIFICACIÓN </Button>
                    </Col>
                </>
            </Row>

            
            {tablaNotificacionEmbarazos}

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento de notificación de embarazo'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />
            <ModalConfirmacion
                show={stateModal.showModal }
                size="xl"
                mensajeConfirmacion={'¿Desea registrar la interrupción de su embarazo?'}
                classNamemensajeConfirmacion='mensajeConfirmacionAnulacionSolicitud'
                tituloModal='Interrupción de embarazo'
                nombreBotonAccion='Aceptar'
                nombreBotonCerrarModal='Cancelar'
                onClose={() => setstateModal(defaultStateModal)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                asyncOnClick={async () => AnularNotificacion(stateModal.notificacion?.idembarazo ?? -1, fechaInterrupcion)}
                asyncAfterOnClose={() => OnCloseModalConfirmacionAnulacion()}
                contentModal={stateModal.content}
                classNameAllModal={""}
                classNameContentModal='custom-modal-style-interrupcion'

            />
        </div>
    )
}